<template>
  <div :class="[$attrs.class, 'h-32px text-lighter-grey-4 hover:bg-white px-16px py-6px leading-5 w-full']">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'BaseDropdownItem',
}
</script>

<style></style>
